export default "__VITE_ASSET__CPp1tc3l__"